//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['level']
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/components/VipLevel/index.vue